<template>
  <UITooltip v-if="model.description_long" placement="right" :offset="[0, 24]">
    <template #trigger>
      <DropdownModelItem
        class="DropdownModel__list-item"
        :model="model"
        :isSelected="isSelected"
      />
    </template>
    <template #content>
      {{ model.description_long }}
    </template>
  </UITooltip>

  <DropdownModelItem
    v-else
    class="DropdownModel__list-item"
    :model="model"
    :isSelected="isSelected"
  />
</template>

<script lang="ts" setup>
import { UITooltip } from '@foundever/ui-lib'

import type { IModel } from '@/apiClient/types/model'

import DropdownModelItem from './DropdownModelItem.vue'

defineProps<{
  model: IModel
  isSelected?: boolean
}>()
</script>
